var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.59,277.148 39.595,277.139 39.59,277.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "472.41,314.05 452.281,293.922 274.451,471.733 59.719,257.001 39.595,277.139 274.451,512  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.451,422.737l187.894-187.885L237.548,10.065L39.59,0l10.064,197.95L274.451,422.737z M116.768,77.16 c12.974-12.974,33.992-12.974,46.967,0c12.974,12.984,12.974,34.002,0,46.976c-12.974,12.974-33.992,12.974-46.967,0 C103.794,111.162,103.794,90.144,116.768,77.16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.a4582bc7305cd37fad7118a4c9802998.svg";
export { ForwardRef as ReactComponent };